import React from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import StaticLayoutDesktop from 'layouts/static/static.desktop';
import CompanyRulesBase from './company-rules.base';

const CompanyRulesDesktop: React.FC<{ title: string; }> = ({ title }) => (
    <StaticLayoutDesktop title={title}>
        <CompanyRulesBase />
    </StaticLayoutDesktop>
);

export default withHydrate(CompanyRulesDesktop, { root: '#root' }, 'views/pages/static/company-rules/company-rules.desktop');
